module.exports = __webpack_public_path__ + "img/save.22b2e547.svg";